// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------
let keyboardActive = false;

document.addEventListener('visibilitychange', () => {
  // when document becomes visible, it wil also fire a focus
  // event on interactive elements (in case they were focused before)
  // this could enable focus outline (in case last interaction was a keystroke)
  // it seems like the order of the focus and visibilitychange event is not guaranteed
  // for this we explicitly set keyboardActive to false every time a document gets shown or hidden
  // IMPORTANT: this logic has one short coming currently
  // when we switch between tabs in the browser, the focus outline
  // that is currently shown will be lost (it will only be shown again when focusing another element via keyboard again)
  keyboardActive = false;
});

document.addEventListener(
  'keydown',
  () => {
    keyboardActive = true;
  },
  { capture: true } // capture is needed to catch the event even if it is handled downstream
);

document.addEventListener(
  'pointerdown',
  () => {
    keyboardActive = false;
  },
  { capture: true } // capture is needed to catch the event even if it is handled downstream
);

export function isKeyboardActive() {
  return keyboardActive;
}
